import { filter, get, head, isEmpty, map } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import type { SellingPoint, SellingPointGroup } from '../../../../../types/sanity';

const mapSellingPointsContent = ({ refersToContent }: any) => {
  const sellingPointGroups = filter(
    (section) => get('__typename', section) === CONTENT_SECTIONS.SELLING_POINTS_GROUP,
    refersToContent,
  ) as SellingPointGroup[];
  if (isEmpty(sellingPointGroups)) {
    return null;
  }

  // TODO: hard-coded for now as title is not on the model. Maybe derive this from a data file based on the
  // page being rendered (which is just /health-insurance for now but could be something else in the future)
  const title = 'Find private health cover to suit your needs';

  const groups = map(
    (sellingPointGroup: SellingPointGroup) => ({
      contentTitle: sellingPointGroup.name,
      cta: {
        name: sellingPointGroup.cta?.name,
        url: sellingPointGroup.cta?.url,
      },
      description: sellingPointGroup.summary,
      sellingPoints: map(
        (sellingPoint: SellingPoint) => ({
          description: sellingPoint.summary,
          title: sellingPoint.name,
        }),
        sellingPointGroup.sellingPointGroup,
      ),
      tabTitle: sellingPointGroup.name,
      title: sellingPointGroup.name,
    }),
    sellingPointGroups,
  );

  const mappedCmsContent = {
    groups,
    orderIndex: get('orderIndex', head(sellingPointGroups)),
    title,
    type: CONTENT_SECTIONS.SELLING_POINTS_GROUP,
  };

  return mappedCmsContent;
};

export default mapSellingPointsContent;
